const getEnsemblId = (state) =>
  state.variantResult?.identifiers?.ensembl_id &&
  state.variantResult?.identifiers?.ensembl_id[0];

export { getEnsemblId };
